import { LayoutContext } from 'contexts/LayoutContext';
import React, { useContext } from 'react';
import { useModalView } from '@/design-system/components/modal/useModalView.hook';

import { CreateCardAccountStackRoutes, CreateCardAccountStackScreenProps } from './type';
import { CreateCardAccountWebOneScreen } from './CreateCardAccountWebOne.screen';
import { CreateCardAccountNativeOneScreen } from './CreateCardAccountNativeOne.screen';

export const CreateCardAccountConfirm: React.FC<CreateCardAccountStackScreenProps<CreateCardAccountStackRoutes.Confirm>> = ({
  navigation,
  route
}) => {
  const { onLayout, data, func, onReturnData, refresh, onChangeView } = route.params;
  const layout = useContext(LayoutContext);
  const onGoBack = () => {
    navigation.goBack();
  };
  const { useModalProps, closeModal } = useModalView({});
  if (layout.isMobile) {
    return (
      <CreateCardAccountNativeOneScreen
        onClose={onGoBack}
        onLayout={onLayout}
        data={data}
        func={func}
        onReturnData={onReturnData}
        refresh={refresh}
      />
    );
  }

  return (
    <CreateCardAccountWebOneScreen
      onClose={closeModal}
      onLayout={onLayout}
      data={data}
      func={func}
      onReturnData={onReturnData}
      refresh={refresh}
      onChangeView={onChangeView}
    />
  );
};
